<template>
  <v-container>
    <h1>{{ $t(`entities.machine.multiple`) }}</h1>
    <v-row>
      <v-col cols="4">
        <v-data-table
          :headers="headers"
          :items="machines">
          <template #item="{ item, index }">
            <tr @click="activeMachine = index">
              <td>{{ item.name }}</td>
              <td>{{ item.id_number_machine }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        cols="8"
        v-if="activeMachine !== null">
        <MachineView
          :machine="machines[activeMachine]"
          @edit="
            dialogOptions = { open: true, id: machines[activeMachine].id }
          " />
      </v-col>
    </v-row>

    <v-btn v-if="authStore.isDatabaseAdmin" @click="dialogOptions = { open: true, id: null }">{{
      $t(`entities.machine.create`)
    }}</v-btn>

    <v-dialog v-model="dialogOptions.open">
      <MachineEdit
        :id="dialogOptions.id"
        @save="editComplete" />
    </v-dialog>
  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import MachineEdit from "./MachineEdit.vue";
import MachineView from "./MachineView.vue";

import { useSpaceStore } from "@/stores/spaceStore";

import { onMounted } from "vue";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { useAuthStore } from "@/stores/authStore";
const { t } = useTranslation();

const activeMachine = ref(null);

const spaceStore = useSpaceStore();
const authStore = useAuthStore()

const router = useRouter();

const dialogOptions = ref({ open: false, id: null });

const headers = [
  { title: t("entities.machine.name"), value: "name" },
  {
    title: t("entities.machine.fields.id_number_machine"),
    value: "id_number_machine"
  }
];

const machines = ref([]);

onMounted(async () => {
  machines.value = await axios
    .get("/api/database/machine/list")
    .then((res) => res.data);
});

async function editComplete() {
  dialogOptions.value = { open: false, id: null };
  machines.value = await axios
    .get("/api/database/machine/list")
    .then((res) => res.data);
}
</script>
